import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Navigation } from "swiper/modules"

export default class extends Controller {
	static targets = ["slider", "nextButton", "prevButton", "counter"]

	connect() {
		this.slider = new Swiper(this.sliderTarget, {
			modules: [ Navigation ],
			loop: false,
			slidesPerView: 1,
			spaceBetween: 24,
			navigation: {
				nextEl: this.nextButtonTarget,
				prevEl: this.prevButtonTarget
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 24,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 48,
				},
				1280: {
					slidesPerView: 3,
					spaceBetween: 48,
				}
			},
			on: {
				slideChange: () => {
					this.counterTarget.innerText = `${this.slider?.realIndex + 1} / ${this.slider?.slides.length}`
				},
			}
		})

		this.counterTarget.innerText = `${this.slider?.realIndex + 1} / ${this.slider?.slides.length}`
	}
}
